import { useMutation } from "@apollo/client/react";
import { handleApolloResult } from "@repo/apollo-utils";
import { useCallback } from "react";
import { graphql } from "src/gql/graphql";

const CreateCsChatJwtTokenMutation = graphql(
  `
    mutation CreateCsChatJwtTokenMutation($input: CreateCsChatJwtTokenInput!) {
      createCsChatJwtToken(input: $input)
    }
  `,
);

export const useCreateCsChatJwtToken = () => {
  const [createCsChatJwtToken] = useMutation(CreateCsChatJwtTokenMutation);

  return useCallback(async (): Promise<string> => {
    const result = await handleApolloResult(
      createCsChatJwtToken({
        variables: {
          input: {},
        },
      }),
    );

    if (result.error) {
      throw result.error;
    }

    return result.data.createCsChatJwtToken;
  }, [createCsChatJwtToken]);
};
